import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, createSlots as _createSlots, renderList as _renderList, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "modal__title modal__title--lg" };
const _hoisted_2 = { itemprop: "name" };
const _hoisted_3 = { key: 0 };
const _hoisted_4 = {
    key: 0,
    class: "list__item"
};
const _hoisted_5 = {
    key: 1,
    class: "form-group"
};
const _hoisted_6 = { class: "form-field form-field--text form-field--1 form-field--m form-field--primary" };
const _hoisted_7 = { class: "line line--aic" };
const _hoisted_8 = { class: "line__item" };
const _hoisted_9 = { class: "text text--sm" };
const _hoisted_10 = { class: "line__item line__item--mla" };
const _hoisted_11 = ["disabled"];
const _hoisted_12 = {
    key: 0,
    class: "line__item"
};
const _hoisted_13 = ["disabled"];
const _hoisted_14 = { class: "btn__label" };
const _hoisted_15 = { class: "line__item" };
const _hoisted_16 = ["data-id"];
const _hoisted_17 = { class: "btn__icon" };
const _hoisted_18 = { class: "line__item" };
const _hoisted_19 = ["data-id"];
const _hoisted_20 = { class: "btn__icon" };
const _hoisted_21 = {
    key: 0,
    class: "line__item line__item--mla"
};
const _hoisted_22 = ["disabled"];
const _hoisted_23 = {
    key: 0,
    class: "line__item line__item--mla"
};
const _hoisted_24 = ["href"];
const _hoisted_25 = {
    key: 1,
    class: "line__item"
};
const _hoisted_26 = ["data-id", "disabled"];
const _hoisted_27 = { class: "btn__icon" };
const _hoisted_28 = ["innerHTML"];
import { computed, onMounted, onUnmounted, ref, watch } from "vue";
import ModalDialog from "../../components/modal/ModalDialog.vue";
import Sprite from "../../components/Sprite.vue";
import Toast from "../../components/Toast.vue";
import Toasts from "../../components/Toasts.vue";
import UserSetItemsList from "./components/UserSetItemsList.vue";
import EventBus from "../../events/EventBus";
import { hidePreloader, showPreloader } from "../../components/preloader";
import { showModalFromHtml } from "../../components/modal";
import { handleAddToCartButtonClick } from "../../components/product/add_to_cart";
import { useSetsApi } from "./api";
import Message from "../../components/Message.vue";
const DEFAULT_ERROR_MESSAGE = 'Произошла ошибка работы с сетом';
export default /*@__PURE__*/ _defineComponent({
    __name: 'UserSetModal',
    props: {
        set: { type: Object, required: true },
        mode: { type: String, default: 'constructor' },
        authorized: { type: Boolean, default: false },
        status: { type: String, default: 'create' },
        cartProduct: { type: Object, default: null },
        open: { type: Boolean, default: true }
    },
    setup(__props, { expose: __expose }) {
        const props = __props;
        const api = useSetsApi();
        const modal = ref();
        // Аромат, ожидающий выбора позиции для замены
        const pendingOffer = ref(null);
        const saving = ref(false);
        const currentUuid = ref(props.set.uuid ?? null);
        const currentName = ref(props.set.name);
        const lastSavedName = ref(props.set.name);
        const setContent = ref([...props.set.content]);
        const isAuthorized = ref(props.authorized);
        const warnings = ref([]);
        const maxItems = computed(() => props.set.maxItems);
        const userAuthorized = computed(() => props.authorized || isAuthorized.value);
        const replacementMode = computed(() => !!pendingOffer.value);
        const canSubmit = computed(() => !saving.value && currentName.value.trim().length > 0 && setContent.value.length === maxItems.value);
        const canBuy = computed(() => setContent.value.every(item => item.available));
        const showPrice = computed(() => !props.cartProduct?.url && props.mode !== 'history');
        function applySetData(set) {
            if (set.uuid !== undefined) {
                currentUuid.value = set.uuid ?? null;
            }
            if (set.name !== undefined) {
                currentName.value = set.name;
                lastSavedName.value = set.name;
            }
            if (set.content) {
                setContent.value = [...set.content];
            }
        }
        watch(() => props.set, applySetData);
        function removeWarning(id) {
            warnings.value = warnings.value.filter(w => w.id !== id);
        }
        function showError(message) {
            warnings.value.push({ id: `warning-${Date.now()}-${Math.random()}`, text: message });
        }
        /**
         * Выполняет запрос к API сетов: блокирует кнопки на время запроса, рассылает обновлённое состояние сета,
         * при ошибке показывает её текст и вызывает rollback. Возвращает null при ошибке
         */
        async function run(request, rollback) {
            saving.value = true;
            try {
                const response = await request;
                if (!response.ok) {
                    showError(Object.values(response.error ?? {})[0] || DEFAULT_ERROR_MESSAGE);
                    rollback?.();
                    return null;
                }
                if (response.data) {
                    EventBus.emit('set:update', response.data);
                }
                return response;
            }
            catch (e) {
                console.error('API Request Error:', e);
                showError(DEFAULT_ERROR_MESSAGE);
                rollback?.();
                return null;
            }
            finally {
                saving.value = false;
            }
        }
        function show() {
            modal.value?.open();
        }
        function close() {
            modal.value?.close();
        }
        __expose({ show });
        function handleReplacementRequest(offer) {
            if (props.mode !== 'constructor') {
                return;
            }
            pendingOffer.value = { id: offer.id, name: offer.name };
            show();
        }
        async function replaceItemByIndex(index) {
            if (pendingOffer.value && await run(api.replaceItem(index, pendingOffer.value.id))) {
                pendingOffer.value = null;
            }
        }
        async function removeByIndex(index) {
            if (await run(api.removeItem(index)) && setContent.value.length === 0) {
                close();
            }
        }
        async function saveSet() {
            if (!canSubmit.value) {
                return;
            }
            const ids = setContent.value.map(item => item.offerId);
            // После успешного сохранения будет редирект — прелоадер показываем сразу и не скрываем при переходе
            showPreloader();
            const response = await run(api.saveSet(currentName.value.trim(), ids, currentUuid.value));
            if (response?.ok && response.redirect) {
                window.location.href = response.redirect;
                return;
            }
            hidePreloader();
            // Сохранение отклонено сервером (достигнут лимит сетов) — показываем присланное окно
            if (response?.ok && response.html) {
                showModalFromHtml(response.html);
            }
        }
        async function addToCart() {
            if (!canSubmit.value || !canBuy.value) {
                return;
            }
            saving.value = true;
            try {
                const type = props.mode === 'constructor' ? 'draft' : 'user_set';
                // Черновик после добавления очищается, поэтому окно конструктора закрываем. Сохранённый сет остаётся открытым под окном корзины
                if (await handleAddToCartButtonClick({ type, id: currentUuid.value }) && props.mode === 'constructor') {
                    close();
                }
            }
            finally {
                saving.value = false;
            }
        }
        async function updateName() {
            const name = currentName.value.trim();
            if (!name) {
                currentName.value = lastSavedName.value;
            }
            else if (name !== lastSavedName.value) {
                await run(api.rename(name), () => currentName.value = lastSavedName.value);
            }
        }
        function handleExternalUpdate(data) {
            // Событие несёт состояние черновика конструктора — к сохранённому сету оно не относится
            if (data?.set && props.mode === 'constructor') {
                applySetData(data.set);
            }
            if (data.authorized !== undefined) {
                isAuthorized.value = !!data.authorized;
            }
        }
        function handleModalClose(closedModal) {
            if (closedModal?.id === 'user-set-modal') {
                pendingOffer.value = null;
            }
        }
        onMounted(() => {
            EventBus.on('set:update', handleExternalUpdate);
            EventBus.on('set:replacement-requested', handleReplacementRequest);
            EventBus.on('modal:close', handleModalClose);
        });
        onUnmounted(() => {
            EventBus.off('set:update', handleExternalUpdate);
            EventBus.off('set:replacement-requested', handleReplacementRequest);
            EventBus.off('modal:close', handleModalClose);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(ModalDialog, {
                    id: "user-set-modal",
                    size: "lg",
                    ref_key: "modal",
                    ref: modal,
                    open: __props.open
                }, _createSlots({
                    top: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("span", _hoisted_2, [
                                _cache[1] || (_cache[1] = _createTextVNode("Состав сета", -1 /* CACHED */)),
                                (__props.mode !== 'constructor')
                                    ? (_openBlock(), _createElementBlock("strong", _hoisted_3, " «" + _toDisplayString(currentName.value) + "»", 1 /* TEXT */))
                                    : _createCommentVNode("v-if", true)
                            ])
                        ])
                    ]),
                    main: _withCtx(() => [
                        _createVNode(UserSetItemsList, {
                            items: setContent.value,
                            mode: __props.mode,
                            showPrice: showPrice.value,
                            replacementMode: replacementMode.value,
                            saving: saving.value,
                            onReplace: replaceItemByIndex,
                            onRemove: removeByIndex
                        }, null, 8 /* PROPS */, ["items", "mode", "showPrice", "replacementMode", "saving"])
                    ]),
                    bottom: _withCtx(() => [
                        _createElementVNode("div", _hoisted_7, [
                            (__props.mode === 'constructor')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createElementVNode("div", _hoisted_8, [
                                        _createElementVNode("div", _hoisted_9, "Вы выбрали " + _toDisplayString(setContent.value.length) + " из " + _toDisplayString(maxItems.value) + " ароматов", 1 /* TEXT */)
                                    ]),
                                    _cache[5] || (_cache[5] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_10, [
                                        _createElementVNode("button", {
                                            type: "button",
                                            class: "btn btn--1 btn--m btn--black",
                                            onClick: addToCart,
                                            disabled: !canSubmit.value || !canBuy.value || replacementMode.value
                                        }, [...(_cache[4] || (_cache[4] = [
                                                _createElementVNode("span", { class: "btn__label" }, "В корзину", -1 /* CACHED */)
                                            ]))], 8 /* PROPS */, _hoisted_11)
                                    ]),
                                    _cache[6] || (_cache[6] = _createTextVNode()),
                                    (userAuthorized.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                            _createElementVNode("button", {
                                                type: "button",
                                                class: "btn btn--2 btn--m btn--black",
                                                onClick: saveSet,
                                                disabled: !canSubmit.value || replacementMode.value
                                            }, [
                                                _createElementVNode("span", _hoisted_14, _toDisplayString(saving.value ? 'Сохранение...' : 'Сохранить сет'), 1 /* TEXT */)
                                            ], 8 /* PROPS */, _hoisted_13)
                                        ]))
                                        : _createCommentVNode("v-if", true)
                                ], 64 /* STABLE_FRAGMENT */))
                                : _createCommentVNode("v-if", true),
                            _cache[17] || (_cache[17] = _createTextVNode()),
                            (__props.mode === 'profile')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createElementVNode("div", _hoisted_15, [
                                        _createElementVNode("button", {
                                            type: "button",
                                            class: "btn btn--2 btn--m btn--black win",
                                            "data-act": "user_set_edit",
                                            "data-id": currentUuid.value
                                        }, [
                                            _createElementVNode("span", _hoisted_17, [
                                                _createVNode(Sprite, { name: "edit" })
                                            ]),
                                            _cache[7] || (_cache[7] = _createTextVNode()),
                                            _cache[8] || (_cache[8] = _createElementVNode("span", { class: "btn__label" }, "Редактировать", -1 /* CACHED */))
                                        ], 8 /* PROPS */, _hoisted_16)
                                    ]),
                                    _cache[12] || (_cache[12] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_18, [
                                        _createElementVNode("button", {
                                            type: "button",
                                            class: "btn btn--2 btn--m btn--gray win",
                                            "data-act": "user_set_delete",
                                            "data-id": currentUuid.value
                                        }, [
                                            _createElementVNode("span", _hoisted_20, [
                                                _createVNode(Sprite, { name: "remove" })
                                            ]),
                                            _cache[9] || (_cache[9] = _createTextVNode()),
                                            _cache[10] || (_cache[10] = _createElementVNode("span", { class: "btn__label" }, "Удалить", -1 /* CACHED */))
                                        ], 8 /* PROPS */, _hoisted_19)
                                    ]),
                                    _cache[13] || (_cache[13] = _createTextVNode()),
                                    (canBuy.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                            _createElementVNode("button", {
                                                type: "button",
                                                class: "btn btn--1 btn--m btn--black",
                                                onClick: addToCart,
                                                disabled: !canSubmit.value
                                            }, [...(_cache[11] || (_cache[11] = [
                                                    _createElementVNode("span", { class: "btn__label" }, "В корзину", -1 /* CACHED */)
                                                ]))], 8 /* PROPS */, _hoisted_22)
                                        ]))
                                        : _createCommentVNode("v-if", true)
                                ], 64 /* STABLE_FRAGMENT */))
                                : _createCommentVNode("v-if", true),
                            _cache[18] || (_cache[18] = _createTextVNode()),
                            (__props.mode === 'cart')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    (__props.cartProduct?.url)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                            _createElementVNode("a", {
                                                href: __props.cartProduct.url,
                                                class: "btn btn--2 btn--m btn--black"
                                            }, [...(_cache[14] || (_cache[14] = [
                                                    _createElementVNode("span", { class: "btn__label" }, "На страницу сета", -1 /* CACHED */)
                                                ]))], 8 /* PROPS */, _hoisted_24)
                                        ]))
                                        : (userAuthorized.value)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                                _createElementVNode("button", {
                                                    type: "button",
                                                    class: "btn btn--2 btn--m btn--black win",
                                                    "data-act": "user_set_edit",
                                                    "data-id": currentUuid.value,
                                                    disabled: !canSubmit.value
                                                }, [
                                                    _createElementVNode("span", _hoisted_27, [
                                                        _createVNode(Sprite, { name: "edit" })
                                                    ]),
                                                    _cache[15] || (_cache[15] = _createTextVNode()),
                                                    _cache[16] || (_cache[16] = _createElementVNode("span", { class: "btn__label" }, "Редактировать", -1 /* CACHED */))
                                                ], 8 /* PROPS */, _hoisted_26)
                                            ]))
                                            : _createCommentVNode("v-if", true)
                                ], 64 /* STABLE_FRAGMENT */))
                                : _createCommentVNode("v-if", true)
                        ])
                    ]),
                    _: 2 /* DYNAMIC */
                }, [
                    (__props.mode === 'constructor')
                        ? {
                            name: "under_top",
                            fn: _withCtx(() => [
                                (pendingOffer.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                        _createVNode(Message, {
                                            gray: "",
                                            icon: "attention-circle"
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode("\n          Чтобы добавить «" + _toDisplayString(pendingOffer.value.name) + "», выберите аромат для замены.\n        ", 1 /* TEXT */)
                                            ]),
                                            _: 1 /* STABLE */
                                        })
                                    ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                        _cache[2] || (_cache[2] = _createElementVNode("label", {
                                            class: "form-label",
                                            for: "set_name"
                                        }, "Название сета", -1 /* CACHED */)),
                                        _cache[3] || (_cache[3] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_6, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                name: "set_name",
                                                class: "form-control",
                                                id: "set_name",
                                                required: "",
                                                placeholder: "Мой сет",
                                                maxlength: "100",
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((currentName).value = $event)),
                                                onBlur: updateName
                                            }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                                                [_vModelText, currentName.value]
                                            ])
                                        ])
                                    ]))
                            ]),
                            key: "0"
                        }
                        : undefined
                ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["open"]),
                _cache[22] || (_cache[22] = _createTextVNode()),
                _createVNode(Toasts, { teleport: "#user-set-modal" }, {
                    default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(warnings.value, (warning) => {
                            return (_openBlock(), _createBlock(Toast, {
                                progress: "",
                                "auto-hide": "",
                                icon: "warning",
                                key: warning.id,
                                onClose: ($event) => (removeWarning(warning.id))
                            }, {
                                default: _withCtx(() => [
                                    _createElementVNode("span", {
                                        innerHTML: warning.text
                                    }, null, 8 /* PROPS */, _hoisted_28)
                                ]),
                                _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClose"]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _: 1 /* STABLE */
                })
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
